import {Injectable, Type} from '@angular/core';
import {Observable, of} from "rxjs";
import {MatBottomSheet, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {WrenchBottomSheetComponent} from "./wrench-bottom-sheet.component";

@Injectable()
export class WrenchBottomSheetService {

    constructor(private bottomSheet: MatBottomSheet) {
    }

    open(content: Type<any>, header?: Type<any>, footer?: Type<any>, config: any = {panelClass: []}): Observable<MatBottomSheetRef<any>> {

        config.data = {
            headerType: header,
            contentType: content,
            footerType: footer,
        };

        if (config?.panelClass?.length > 0) {
            config.panelClass.push('wrench-bottom-sheet');
        } else {
            config.panelClass = 'wrench-bottom-sheet';
        }

        let bottomSheetRef = this.bottomSheet.open(WrenchBottomSheetComponent, config);

        bottomSheetRef.instance.headerType = header;
        bottomSheetRef.instance.contentType = content;
        bottomSheetRef.instance.footerType = footer;

        bottomSheetRef.instance.init();

        return of(bottomSheetRef);
    } // open()
}
